module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"og_image":"/images/og-image-en.jpg"},"nl":{"og_image":"/images/og-image.jpg"}}')
  delete Component.options._Ctor
}
